import type { ExchangeSegmentPartnerPlatformShareCreateParams } from '@openx/types/gqlTypes';

export type SegmentPartnerShare = {
  partner_id?: string;
  share?: string | number | null;
};

const createPartnerShareLookup = (
  shares: Array<SegmentPartnerShare | null> | null | undefined
): Map<string, string | number> => {
  const lookup = new Map<string, string | number>();

  if (!Array.isArray(shares)) return lookup;

  for (const entry of shares) {
    if (entry?.partner_id != null && entry.share != null) {
      lookup.set(String(entry.partner_id), entry.share);
    }
  }

  return lookup;
};

const normalizeShareValue = (share: string | number | null | undefined): string => {
  if (share == null) return '';

  return typeof share === 'number' ? String(share) : share;
};

export const createOrderedPartnerShares = (
  orgIds: string[],
  currentShares: Array<SegmentPartnerShare | null> | null | undefined
): ExchangeSegmentPartnerPlatformShareCreateParams[] => {
  const shareLookup = createPartnerShareLookup(currentShares);

  return orgIds.map((orgId: string) => {
    const share = normalizeShareValue(shareLookup.get(orgId));

    return { partner_id: orgId, share };
  });
};

export const needsPartnerShareSync = (
  currentShares: Array<SegmentPartnerShare | null> | null | undefined,
  orderedShares: ExchangeSegmentPartnerPlatformShareCreateParams[]
): boolean => {
  if (!Array.isArray(currentShares)) return true;

  if (currentShares.length !== orderedShares.length) return true;

  return orderedShares.some(
    (entry: ExchangeSegmentPartnerPlatformShareCreateParams, i: number) =>
      currentShares[i]?.partner_id !== entry.partner_id
  );
};
